import Cookies from 'js-cookie';
import { StateCreator } from 'zustand';

import { CommonStoreType, PlayerState } from '../types';
import { COOKIE_NAME } from '@/helpers/cookie';

export const usePlayerSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  PlayerState
> = () => {
  return {
    playerFields: undefined,
    playerSettings: undefined,
    pendingPlayerSettings: true,
    lastSuccessfulPaymentsByCurrency: {},
    lastSuccessfulPaymentsByCurrencyPending: false,
    isAuthenticatedByCookie:
      Cookies.get(COOKIE_NAME.IS_AUTHENTICATED) === 'true',
  };
};
